export default {
	firstName: 'user.firstName',
	lastName: 'user.lastName',
	email: 'user.email',
	userName: 'user.userName',
	password: 'user.password',
	confirmPassword: 'user.confirmPassword',
	phoneNumber: 'user.phoneNumber',
	dob: 'user.dob',
	location: 'user.location',
	gender: 'user.gender'
};
